import { useMemo } from 'react'

import { ContactCompanyType } from 'models/contact_companies'
import { LodgingChainProxy } from 'models/google_place_chain'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { DataTableColumnSort } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { useGooglePlacesBaseTableCols } from '../../GooglePlaceBase/GooglePlaceBaseTable/GooglePlaceBaseTableColumns'
import { useHotelAmenitiesColumn } from '../useHotelAmenitiesColumn'
import { LODGING_COLUMNS } from '../LodgingColumnsInfo'

export const useLodgingTableCols = ({
  sorting,
  inCampaigns,
}: {
  sorting?: DataTableColumnSort[]
  inCampaigns?: boolean
}) => {
  const { enableLodgingHotelAmenities } = useFeatureFlagService()
  const commonColumns = useGooglePlacesBaseTableCols({
    sorting,
    inCampaigns,
    accesor: 'lodging',
    tableColumns: LODGING_COLUMNS,
    linkPrefix: 'lodging/chain',
    companyType: ContactCompanyType.Lodging,
  })

  const amenitiesColumn = useHotelAmenitiesColumn<
    LodgingChainProxy,
    typeof LODGING_COLUMNS
  >(LODGING_COLUMNS)

  return useMemo(
    () =>
      enableLodgingHotelAmenities
        ? [...commonColumns, amenitiesColumn]
        : commonColumns,
    [commonColumns, amenitiesColumn, enableLodgingHotelAmenities]
  )
}
